/**
 * Maps an AI-report API error to a localized, user-facing message.
 *
 * The backend sends a machine-readable `errorCode` (e.g. INSUFFICIENT_CREDITS,
 * REPORT_ACCESS_DENIED) on the error body. The `_services` reject with
 * `error.response`, so the body is at `err.data`. When a matching
 * `reports.errors.<CODE>` translation exists we use it; otherwise we fall back
 * to the caller's generic key.
 */
export default {
  methods: {
    reportErrorMessage(err, fallbackKey) {
      const code = err && err.data && err.data.errorCode;
      if (code) {
        const key = `reports.errors.${code}`;
        if (this.$te(key)) return this.$t(key);
      }
      return this.$t(fallbackKey);
    },
  },
};
